import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.117 10c-.993 0-1.49-1.174-.788-1.861l2.883-2.82a1.133 1.133 0 0 1 1.576 0l2.883 2.82c.703.687.205 1.861-.788 1.861zM14.883 14c.993 0 1.49 1.174.788 1.861l-2.883 2.82a1.133 1.133 0 0 1-1.576 0l-2.883-2.82C7.626 15.174 8.124 14 9.117 14z"
    }, null, -1)
  ])))
}
export default { render: render }